/* eslint-disable default-case */
import { SearchModes } from '@/domainLogic/index.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { Analytics } from './Analytics';
import type { CuriosityParams } from './index';
import { getMarket } from './utils';
import type { RedirectParams } from './Analytics/utils';
import { PlatformEnum } from './Analytics/utils/PlatformEnum';
import { EventsEnum } from './Analytics/utils/EventsEnum';
import type { Localization } from '../common/Localization';

type RedirectEvent = {
  redirectParams: RedirectParams;
  searchMode: string;
  offset?: number;
  url: string;
  group: number;
  searchId: string;
  commonData: CommonData;
  localization: Localization;
  curiosityParams: CuriosityParams;
};

const redirectEvent = ({
  redirectParams,
  searchMode,
  offset,
  url,
  group,
  searchId,
  commonData,
  localization,
  curiosityParams,
}: RedirectEvent): void => {
  const { brand, country } = localization;
  const { isApp } = commonData;
  const platform = isApp ? PlatformEnum.APP : PlatformEnum.TSX;
  const analytics = new Analytics({
    market: getMarket(country),
    platform,
    brand,
    url,
    group,
    searchId,
    commonData,
    curiosityParams,
    localization,
    AbortController,
  });
  let type = EventsEnum.DP_REDIRECT;
  switch (searchMode) {
    case SearchModes.DP:
      type = EventsEnum.DP_REDIRECT;
      break;
    case SearchModes.HO:
      type = EventsEnum.HO_REDIRECT;
      break;
    case SearchModes.FF:
      type = EventsEnum.FF_REDIRECT;
      break;
  }

  try {
    analytics.redirectEvent({ offset: offset || 0, type, redirectParams });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
};

export default redirectEvent;
